import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "edit-profile-dialog__inner"
};
const _hoisted_2 = {
  class: "edit-profile-dialog__hero"
};
const _hoisted_3 = {
  class: "edit-profile-dialog__hero-text"
};
const _hoisted_4 = {
  class: "edit-profile-dialog__hero-name"
};
const _hoisted_5 = {
  class: "edit-profile-dialog__hero-sub"
};
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = {
  class: "edit-profile-dialog__scroll"
};
const _hoisted_8 = {
  class: "edit-profile-dialog__section"
};
const _hoisted_9 = {
  class: "edit-profile-dialog__label"
};
const _hoisted_10 = {
  class: "edit-profile-dialog__avatar-row"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "edit-profile-dialog__avatar-actions"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  class: "edit-profile-dialog__avatar-hint"
};
const _hoisted_16 = {
  class: "edit-profile-dialog__label",
  for: "ep-display-name"
};
const _hoisted_17 = {
  class: "edit-profile-dialog__label",
  for: "ep-bio"
};
const _hoisted_18 = {
  class: "edit-profile-dialog__label",
  for: "ep-website"
};
const _hoisted_19 = {
  class: "edit-profile-dialog__label",
  for: "ep-twitter"
};
const _hoisted_20 = {
  class: "edit-profile-dialog__label",
  for: "ep-discord"
};
const _hoisted_21 = {
  class: "edit-profile-dialog__label",
  for: "ep-email"
};
const _hoisted_22 = {
  class: "edit-profile-dialog__footer"
};
const _hoisted_23 = ["disabled"];
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { Upload, Refresh } from '@element-plus/icons-vue';
import { FieldFeedback, SurfaceHint } from '@/components/feedback';
import { getUserProfile, updateUserProfile } from '@/api/user';
import { uploadFile, resolveUploadFileUrl } from '@/api/file';
import { isAllowedCoverImageType } from '@/utils/cover-image-process';
import { RANDOM_AVATAR_DISPLAY_COUNT, RANDOM_AVATAR_POOL_SIZE, prefetchRandomAvatarPool, takeOrFetchRandomAvatars } from '@/utils/random-avatar';
import { resolveMediaUrl } from '@/utils/resolve-media-url';
import ImageCropDialog from '@/components/form/ImageCropDialog.vue';
import PmDialogShell from '@/components/shell/PmDialogShell.vue';
import { trackAnalyticsLog } from '@/utils/analytics-track';
const AVATAR_MAX_BYTES = 5 * 1024 * 1024;
const AVATAR_MAX_DIMENSION = 400;
export default {
  __name: 'EditProfileDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    /** GET /user/profile 返回的数据 */
    profile: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'saved'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      t,
      locale
    } = useI18n();
    const displayNameField = ref('');
    const profileUsername = ref('');
    const bioField = ref('');
    const websiteField = ref('');
    const twitterField = ref('');
    const discordField = ref('');
    const emailField = ref('');
    const joinedDateRaw = ref('');
    const avatarPreviewUrl = ref('');
    const avatarRawUrl = ref('');
    const pendingAvatarFile = ref(null);
    const pendingCropFile = ref(null);
    const cropVisible = ref(false);
    const cropFromRandom = ref(false);
    const cropRefreshing = ref(false);
    const cropFetchError = ref('');
    const randomChoiceItems = ref([]);
    const selectedRandomChoiceId = ref('');
    /** 取消/重开时作废进行中的拉取，避免旧请求写入新一批占位 */
    let randomAvatarFetchGen = 0;
    function revokeRandomChoices() {
      for (const item of randomChoiceItems.value) {
        if (item.src?.startsWith('blob:')) {
          URL.revokeObjectURL(item.src);
        }
      }
      randomChoiceItems.value = [];
      selectedRandomChoiceId.value = '';
    }

    /** 先铺满预占位，再按到达顺序填实图 */
    function seedRandomChoicePlaceholders(count) {
      revokeRandomChoices();
      const n = Math.max(1, Number(count) || RANDOM_AVATAR_DISPLAY_COUNT);
      const stamp = Date.now().toString(36);
      randomChoiceItems.value = Array.from({
        length: n
      }, (_, index) => ({
        id: `ph-${stamp}-${index}`,
        file: null,
        src: '',
        pending: true
      }));
      selectedRandomChoiceId.value = '';
      pendingCropFile.value = null;
    }

    /**
     * 填入下一个预占位；首张同时作为裁剪主图。
     * @returns {boolean} 是否写入成功
     */
    function fillNextRandomChoice(file) {
      if (!(file instanceof File)) return false;
      const idx = randomChoiceItems.value.findIndex(row => row.pending);
      if (idx < 0) return false;
      const prev = randomChoiceItems.value[idx];
      if (prev.src?.startsWith('blob:')) {
        URL.revokeObjectURL(prev.src);
      }
      const next = {
        id: prev.id,
        file,
        src: URL.createObjectURL(file),
        pending: false
      };
      const list = randomChoiceItems.value.slice();
      list[idx] = next;
      randomChoiceItems.value = list;
      if (!pendingCropFile.value) {
        selectedRandomChoiceId.value = next.id;
        pendingCropFile.value = file;
      }
      return true;
    }
    const fileInputRef = ref(null);
    const saving = ref(false);
    const randomAvatarLoading = ref(false);
    const profileLoading = ref(false);
    const surfaceMessage = ref('');
    const surfaceTone = ref('info');
    const displayNameFieldFeedback = ref('');
    const avatarFieldFeedback = ref('');
    const pendingSaveSuccess = ref(false);
    const pendingSavedProfile = ref(undefined);
    const surfaceAutoHideMs = computed(() => ['success', 'info'].includes(surfaceTone.value) ? 1500 : 0);
    function setSurfaceHint(msg, tone) {
      surfaceMessage.value = String(msg ?? '').trim();
      surfaceTone.value = tone;
    }
    function clearSurfaceHint() {
      surfaceMessage.value = '';
    }
    function clearPendingSave() {
      pendingSaveSuccess.value = false;
      pendingSavedProfile.value = undefined;
    }
    function flushPendingSave() {
      if (!pendingSaveSuccess.value) return;
      const profile = pendingSavedProfile.value;
      clearPendingSave();
      clearSurfaceHint();
      emit('saved', profile ?? null);
      emit('update:modelValue', false);
    }
    function onSurfaceHintHide() {
      if (surfaceTone.value === 'success' && pendingSaveSuccess.value) {
        flushPendingSave();
        return;
      }
      if (surfaceTone.value !== 'error') {
        clearSurfaceHint();
      }
    }
    const avatarGradients = ['linear-gradient(135deg, #3b82f6 0%, #a855f7 100%)', 'linear-gradient(135deg, #059669 0%, #0ea5e9 100%)', 'linear-gradient(135deg, #ea580c 0%, #dc2626 100%)', 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)'];
    const avatarGradientIndex = ref(0);
    const avatarInitials = computed(() => {
      const name = displayNameField.value.trim() || profileUsername.value;
      const parts = name.split(/\s+/).filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase().slice(0, 2);
      return name.slice(0, 2).toUpperCase() || 'JD';
    });
    const avatarPreviewStyle = computed(() => {
      const url = avatarPreviewUrl.value;
      if (url) {
        const src = url.startsWith('blob:') ? url : resolveMediaUrl(url);
        return {
          backgroundImage: `url(${src})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      }
      return {
        background: avatarGradients[avatarGradientIndex.value % avatarGradients.length]
      };
    });
    const joinedLine = computed(() => {
      const formatted = formatJoinedDate(joinedDateRaw.value);
      if (formatted) {
        return locale.value.startsWith('zh') ? `${formatted}加入` : `Joined ${formatted}`;
      }
      return locale.value.startsWith('zh') ? t('editProfile.joinedZh') : t('editProfile.joined');
    });
    function formatJoinedDate(isoString) {
      if (!isoString) return '';
      try {
        const d = new Date(isoString);
        if (locale.value.startsWith('zh')) {
          return `${d.getFullYear()} 年 ${d.getMonth() + 1} 月`;
        }
        return d.toLocaleDateString(locale.value, {
          month: 'long',
          year: 'numeric'
        });
      } catch {
        return '';
      }
    }
    function applyProfileFromApi(profile) {
      if (!profile || typeof profile !== 'object') return;
      displayNameField.value = profile.nickName || profile.username || '';
      profileUsername.value = profile.nickName || profile.username || '';
      bioField.value = profile.bio || '';
      websiteField.value = profile.websiteUrl || '';
      twitterField.value = profile.twitter || '';
      discordField.value = profile.discord || '';
      emailField.value = profile.email || '';
      joinedDateRaw.value = profile.createTime || '';
      const prev = avatarPreviewUrl.value;
      if (prev && prev.startsWith('blob:')) {
        URL.revokeObjectURL(prev);
      }
      avatarRawUrl.value = String(profile.avatar ?? '').trim();
      avatarPreviewUrl.value = resolveMediaUrl(avatarRawUrl.value);
      pendingAvatarFile.value = null;
      if (fileInputRef.value) {
        fileInputRef.value.value = '';
      }
    }
    function pickFile() {
      fileInputRef.value?.click();
    }
    function onFileChange(e) {
      const file = e.target.files?.[0];
      if (!file) return;
      if (!isAllowedCoverImageType(file.type)) {
        avatarFieldFeedback.value = t('editProfile.avatarTypeError');
        if (fileInputRef.value) fileInputRef.value.value = '';
        return;
      }
      if (file.size > AVATAR_MAX_BYTES) {
        avatarFieldFeedback.value = t('editProfile.avatarSizeError');
        if (fileInputRef.value) fileInputRef.value.value = '';
        return;
      }
      avatarFieldFeedback.value = '';
      cropFromRandom.value = false;
      revokeRandomChoices();
      pendingCropFile.value = file;
      cropVisible.value = true;
    }
    function applyCroppedAvatar(file) {
      pendingAvatarFile.value = file;
      const prev = avatarPreviewUrl.value;
      if (prev && prev.startsWith('blob:')) {
        URL.revokeObjectURL(prev);
      }
      avatarPreviewUrl.value = URL.createObjectURL(file);
    }
    function onAvatarCropConfirm(file) {
      randomAvatarFetchGen += 1;
      cropVisible.value = false;
      pendingCropFile.value = null;
      cropFromRandom.value = false;
      revokeRandomChoices();
      applyCroppedAvatar(file);
      if (fileInputRef.value) fileInputRef.value.value = '';
    }
    function onAvatarCropCancel() {
      randomAvatarFetchGen += 1;
      cropVisible.value = false;
      pendingCropFile.value = null;
      cropFromRandom.value = false;
      cropRefreshing.value = false;
      revokeRandomChoices();
      if (fileInputRef.value) fileInputRef.value.value = '';
    }
    function onSelectRandomChoice(id) {
      const item = randomChoiceItems.value.find(row => row.id === id);
      if (!item || item.pending || !item.file || cropRefreshing.value) return;
      selectedRandomChoiceId.value = item.id;
      pendingCropFile.value = item.file;
    }
    async function openRandomAvatarCrop() {
      avatarFieldFeedback.value = '';
      cropFetchError.value = '';
      cropFromRandom.value = true;
      const fetchGen = ++randomAvatarFetchGen;
      // 立刻铺 10 个预占位并打开弹窗，再渐进填实图
      seedRandomChoicePlaceholders(RANDOM_AVATAR_DISPLAY_COUNT);
      cropVisible.value = true;
      randomAvatarLoading.value = false;
      let filled = 0;
      await takeOrFetchRandomAvatars(RANDOM_AVATAR_DISPLAY_COUNT, {
        onFile: file => {
          if (fetchGen !== randomAvatarFetchGen) return;
          if (fillNextRandomChoice(file)) filled += 1;
        }
      });
      if (fetchGen !== randomAvatarFetchGen) return;
      if (!filled) {
        throw new Error('RANDOM_AVATAR_FETCH_FAILED');
      }
    }
    async function randomAvatar() {
      if (randomAvatarLoading.value || cropRefreshing.value) return;
      if (fileInputRef.value) fileInputRef.value.value = '';
      randomAvatarLoading.value = true;
      try {
        await openRandomAvatarCrop();
      } catch {
        if (!cropVisible.value) {
          avatarFieldFeedback.value = t('editProfile.avatarProcessError');
        } else {
          cropFetchError.value = t('editProfile.avatarProcessError');
        }
      } finally {
        randomAvatarLoading.value = false;
      }
    }
    async function onAvatarCropRefresh() {
      if (cropRefreshing.value || randomAvatarLoading.value) return;
      cropRefreshing.value = true;
      cropFetchError.value = '';
      const fetchGen = ++randomAvatarFetchGen;
      seedRandomChoicePlaceholders(RANDOM_AVATAR_DISPLAY_COUNT);
      let filled = 0;
      try {
        await takeOrFetchRandomAvatars(RANDOM_AVATAR_DISPLAY_COUNT, {
          onFile: file => {
            if (fetchGen !== randomAvatarFetchGen) return;
            if (!fillNextRandomChoice(file)) return;
            filled += 1;
            // 首张到位即可交互；慢源继续后台填预占位，不锁整页
            if (filled === 1) cropRefreshing.value = false;
          }
        });
        if (fetchGen !== randomAvatarFetchGen) return;
        if (!filled) {
          throw new Error('RANDOM_AVATAR_FETCH_FAILED');
        }
      } catch {
        if (fetchGen === randomAvatarFetchGen) {
          cropFetchError.value = t('editProfile.avatarProcessError');
        }
      } finally {
        if (fetchGen === randomAvatarFetchGen) {
          cropRefreshing.value = false;
        }
      }
    }
    function buildUpdatePayload(avatarOverride) {
      const avatar = avatarOverride !== undefined ? String(avatarOverride ?? '').trim() : avatarRawUrl.value.trim();
      return {
        nickName: displayNameField.value.trim(),
        bio: bioField.value.trim(),
        websiteUrl: websiteField.value.trim(),
        twitter: twitterField.value.trim(),
        discord: discordField.value.trim(),
        avatar
      };
    }
    function close() {
      if (pendingSaveSuccess.value) {
        flushPendingSave();
        return;
      }
      clearSurfaceHint();
      clearPendingSave();
      displayNameFieldFeedback.value = '';
      avatarFieldFeedback.value = '';
      emit('update:modelValue', false);
    }
    async function onSave() {
      if (saving.value || randomAvatarLoading.value) return;
      if (!displayNameField.value.trim()) {
        displayNameFieldFeedback.value = t('editProfile.displayNameRequired');
        return;
      }
      displayNameFieldFeedback.value = '';
      clearSurfaceHint();
      clearPendingSave();
      saving.value = true;
      try {
        let avatarUrl = avatarRawUrl.value.trim();
        if (pendingAvatarFile.value) {
          const uploaded = await uploadFile(pendingAvatarFile.value);
          avatarUrl = resolveUploadFileUrl(uploaded);
          if (!avatarUrl) {
            throw new Error(t('editProfile.uploadFailed'));
          }
        }
        await updateUserProfile(buildUpdatePayload(avatarUrl));
        const freshProfile = await getUserProfile();
        pendingSavedProfile.value = freshProfile;
        pendingSaveSuccess.value = true;
        setSurfaceHint(t('editProfile.saveSuccess'), 'success');
        trackAnalyticsLog({
          key: 'profile.save',
          label: '保存资料',
          value: {
            result: 'success'
          }
        });
      } catch (err) {
        setSurfaceHint(err?.message || t('editProfile.saveFailed'), 'error');
        trackAnalyticsLog({
          key: 'profile.save',
          label: '保存资料',
          value: {
            result: 'fail'
          }
        });
      } finally {
        saving.value = false;
      }
    }
    watch(() => props.modelValue, async open => {
      if (!open) {
        randomAvatarFetchGen += 1;
        cropVisible.value = false;
        pendingCropFile.value = null;
        cropFromRandom.value = false;
        cropRefreshing.value = false;
        cropFetchError.value = '';
        revokeRandomChoices();
        return;
      }
      // 打开资料弹窗即后台预取满池，点「随机」时优先从池取出
      void prefetchRandomAvatarPool(RANDOM_AVATAR_POOL_SIZE);
      clearSurfaceHint();
      clearPendingSave();
      displayNameFieldFeedback.value = '';
      avatarFieldFeedback.value = '';
      if (props.profile) {
        applyProfileFromApi(props.profile);
        return;
      }
      profileLoading.value = true;
      try {
        const profile = await getUserProfile();
        applyProfileFromApi(profile);
      } catch (err) {
        setSurfaceHint(err?.message || t('editProfile.loadFailed'), 'error');
      } finally {
        profileLoading.value = false;
      }
    });
    watch(() => props.profile, profile => {
      if (props.modelValue && profile) {
        applyProfileFromApi(profile);
      }
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(PmDialogShell, {
        "model-value": __props.modelValue,
        "dialog-class": "edit-profile-dialog",
        "sheet-class": "edit-profile-sheet",
        "modal-class": "edit-profile-dialog-overlay",
        "dialog-width": "560px",
        "show-close": false,
        "close-on-click-modal": true,
        "destroy-on-close": "",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.$emit('update:modelValue', $event))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(profileUsername.value), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(joinedLine.value), 1)]), _createElementVNode("button", {
          type: "button",
          class: "edit-profile-dialog__close",
          "aria-label": _ctx.$t('editProfile.close'),
          onClick: close
        }, " × ", 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('editProfile.profilePicture')), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: "edit-profile-dialog__avatar-preview",
          style: _normalizeStyle(avatarPreviewStyle.value),
          "aria-hidden": "true"
        }, [!avatarPreviewUrl.value ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(avatarInitials.value), 1)) : _createCommentVNode("", true)], 4), _createElementVNode("div", _hoisted_12, [_createElementVNode("input", {
          ref_key: "fileInputRef",
          ref: fileInputRef,
          type: "file",
          class: "edit-profile-dialog__file-input",
          accept: "image/*",
          onChange: onFileChange
        }, null, 544), _createElementVNode("button", {
          type: "button",
          class: "edit-profile-dialog__btn edit-profile-dialog__btn--primary",
          disabled: randomAvatarLoading.value || cropVisible.value || cropRefreshing.value,
          onClick: pickFile
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Upload))]),
          _: 1
        }), _createTextVNode(" " + _toDisplayString(_ctx.$t('editProfile.chooseFile')), 1)], 8, _hoisted_13), _createElementVNode("button", {
          type: "button",
          class: "edit-profile-dialog__btn edit-profile-dialog__btn--muted",
          disabled: randomAvatarLoading.value || cropRefreshing.value,
          onClick: randomAvatar
        }, [_createVNode(_component_el_icon, {
          class: _normalizeClass({
            'is-loading': randomAvatarLoading.value
          })
        }, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        }, 8, ["class"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('editProfile.randomAvatar')), 1)], 8, _hoisted_14)])]), _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('editProfile.avatarHint')), 1), _createVNode(_unref(FieldFeedback), {
          message: avatarFieldFeedback.value,
          tone: "error"
        }, null, 8, ["message"])]), _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('editProfile.displayName')), 1), _withDirectives(_createElementVNode("input", {
          id: "ep-display-name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => displayNameField.value = $event),
          type: "text",
          class: "edit-profile-dialog__input",
          onInput: _cache[1] || (_cache[1] = $event => displayNameFieldFeedback.value = '')
        }, null, 544), [[_vModelText, displayNameField.value]]), _createVNode(_unref(FieldFeedback), {
          message: displayNameFieldFeedback.value,
          tone: "warning"
        }, null, 8, ["message"]), _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('editProfile.bio')), 1), _withDirectives(_createElementVNode("textarea", {
          id: "ep-bio",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => bioField.value = $event),
          rows: "4",
          class: "edit-profile-dialog__textarea"
        }, null, 512), [[_vModelText, bioField.value]]), _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('editProfile.websiteUrl')), 1), _withDirectives(_createElementVNode("input", {
          id: "ep-website",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => websiteField.value = $event),
          type: "url",
          class: "edit-profile-dialog__input"
        }, null, 512), [[_vModelText, websiteField.value]]), _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('editProfile.twitter')), 1), _withDirectives(_createElementVNode("input", {
          id: "ep-twitter",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => twitterField.value = $event),
          type: "text",
          class: "edit-profile-dialog__input"
        }, null, 512), [[_vModelText, twitterField.value]]), _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('editProfile.discord')), 1), _withDirectives(_createElementVNode("input", {
          id: "ep-discord",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => discordField.value = $event),
          type: "text",
          class: "edit-profile-dialog__input"
        }, null, 512), [[_vModelText, discordField.value]]), _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('editProfile.email')), 1), _withDirectives(_createElementVNode("input", {
          id: "ep-email",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => emailField.value = $event),
          type: "email",
          class: "edit-profile-dialog__input edit-profile-dialog__input--readonly u-ltr-isolate",
          dir: "ltr",
          readonly: "",
          tabindex: "-1"
        }, null, 512), [[_vModelText, emailField.value]])]), _createElementVNode("footer", _hoisted_22, [surfaceMessage.value ? (_openBlock(), _createBlock(_unref(SurfaceHint), {
          key: 0,
          message: surfaceMessage.value,
          tone: surfaceTone.value,
          "auto-hide-ms": surfaceAutoHideMs.value,
          onHide: onSurfaceHintHide
        }, null, 8, ["message", "tone", "auto-hide-ms"])) : _createCommentVNode("", true), _createElementVNode("button", {
          type: "button",
          class: "edit-profile-dialog__save",
          disabled: saving.value || randomAvatarLoading.value,
          onClick: onSave
        }, _toDisplayString(saving.value ? _ctx.$t('editProfile.saving') : _ctx.$t('editProfile.saveChanges')), 9, _hoisted_23)])])]),
        _: 1
      }, 8, ["model-value"]), cropVisible.value && (pendingCropFile.value || cropFromRandom.value) ? (_openBlock(), _createBlock(ImageCropDialog, {
        key: 0,
        modelValue: cropVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => cropVisible.value = $event),
        file: pendingCropFile.value,
        preset: "circle",
        "output-max-dimension": AVATAR_MAX_DIMENSION,
        "show-refresh": cropFromRandom.value,
        refreshing: cropRefreshing.value,
        "status-error": cropFetchError.value,
        choices: cropFromRandom.value ? randomChoiceItems.value : [],
        "selected-choice-id": selectedRandomChoiceId.value,
        onConfirm: onAvatarCropConfirm,
        onCancel: onAvatarCropCancel,
        onRefresh: onAvatarCropRefresh,
        onSelectChoice: onSelectRandomChoice
      }, null, 8, ["modelValue", "file", "show-refresh", "refreshing", "status-error", "choices", "selected-choice-id"])) : _createCommentVNode("", true)], 64);
    };
  }
};